import React from 'react';
import ReactDom from 'react-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import RootLayout from '@layouts/root-layout';
import store from '@src/store';
import '@styles/index.scss';
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            keepPreviousData: true,
        },
    },
});
ReactDom.render(React.createElement(Provider, { store: store },
    React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(BrowserRouter, { basename: "/" },
            React.createElement(RootLayout, null)),
        React.createElement(ReactQueryDevtools, { initialIsOpen: true }))), document.getElementById('app'));
